/**
 * return 返回距离的字符串
 * @param {*} pointX 用户位置的经纬度
 * @param {*} pointY 目标位置的经纬度
 */
export default function calcDistance (pointX, pointY) {
  const lnglat1 = new AMap.LngLat(pointX.longitude, pointX.latitude)
  const lnglat2 = new AMap.LngLat(pointY.longitude, pointY.latitude)
  return lnglat1.distance(lnglat2) / 1000
}

export const isInView = (point, { ne, sw }) => {
  return point.x > sw.lng && point.x < ne.lng && point.y > sw.lat && point.y < ne.lat
}
